import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedName from 'I18n/components/FormattedName';
import { SuccessIcon } from 'foundations-assets';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Text } from 'foundations-components/components/Text';
import { useAgentStatusMessage } from './AgentStatusMessage';
import { AWAY } from '../constants/agent-state';
import AgentAvatar from '../../shared/components/AgentAvatar';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ResponderOption = ({
  agentId,
  agentState = AWAY,
  AsyncUIAvatar,
  avatar,
  currentAssigneeId,
  email,
  firstName,
  isAssignable,
  lastName,
  responder,
  showCapacityStatus
}) => {
  const agentStatusMessage = useAgentStatusMessage({
    responder,
    showCapacityStatus
  });
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !!isAssignable,
    title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "routing-ui.reassignment.disabledUsersTooltip"
    }),
    placement: "bottom",
    children: /*#__PURE__*/_jsx(MediaObject, {
      align: "center",
      paddingInline: "500",
      paddingBlock: "200",
      "data-test-id": "reassignment-responder-option",
      itemLeft: /*#__PURE__*/_jsx(AgentAvatar, {
        AsyncUIAvatar: AsyncUIAvatar,
        avatar: avatar,
        away: agentState === AWAY,
        disabled: !isAssignable,
        showStatus: Boolean(responder),
        size: "sm"
      }),
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        "data-test-id": "reassignment-dropdown-responder",
        flexWrap: "nowrap",
        children: [/*#__PURE__*/_jsxs(Text, {
          as: "span",
          children: [/*#__PURE__*/_jsx(TruncateString, {
            tooltip: false,
            children: /*#__PURE__*/_jsx(FormattedName, {
              givenName: firstName || undefined,
              familyName: lastName || undefined,
              email: email || undefined
            })
          }), isAssignable && /*#__PURE__*/_jsx(Text, {
            as: "small",
            use: "help",
            children: agentStatusMessage
          })]
        }), agentId === currentAssigneeId && /*#__PURE__*/_jsx(IconHolder, {
          icon: SuccessIcon,
          color: "icon-core-default",
          marginInlineStart: "1200"
        })]
      })
    })
  });
};
ResponderOption.displayName = 'ResponderOption';
export default ResponderOption;